function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { computed, defineComponent, ref, onMounted, getCurrentInstance } from "vue";
import EmptyView from "@pt/views/pt-entry/components/empty-view.vue";
import ProductSelector from "@com/components/product-selector/index.vue";
import productView from "@pt/views/pt-entry/components/product-view.vue";
import { productList } from "@pt/api/veditor";
import _ from "lodash";
import { getPSProjectInfo, relateProductPsProject } from "@ps/api/project";
import { getGmakerProjectInfo, relateProductGmakerProject } from "@pt/api/gmaker/project";
import handleClipboard from "@/utils/clipboard";
import { format } from "date-fns";
import { getProductType } from "@pt/views/pt-entry/common-setting/promote-product/promote-product";
export default defineComponent({
    components: {
        EmptyView: EmptyView,
        ProductSelector: ProductSelector,
        productView: productView
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var handleCreateProduct = function handleCreateProduct() {
            productTab.value = "create";
        };
        var handleSelectProduct = function handleSelectProduct() {
            var _$ref;
            (_$ref = productSelectorRef.value) === null || _$ref === void 0 ? void 0 : _$ref.showDialog();
        };
        var handleSelectedProduct = function handleSelectedProduct(row) {
            productInfo.value = row;
        };
        var productClose = function productClose() {
            productInfo.value = projectInfo.value.product_info;
            productTab.value = "view";
        };
        var openProductDialog = function openProductDialog() {
            emit("changeDialog", true);
        };
        var copyLink = function copyLink(id) {
            handleClipboard(id, {
                target: ".copy-link",
                delegateTarget: document.querySelector("#clipboardElement")
            });
        };
        var getOrientation = function getOrientation(val) {
            // pt项目适配方向默认横屏&竖屏
            if (detailDialog.value.type !== "ps") {
                return "".concat(root.$t("basic.orientationSelector.horizontal"), "&").concat(root.$t("basic.orientationSelector.vertical"));
            }
            // 根据项目信息的orientation  1: 横屏; 2: 竖屏 3: 横屏&竖屏
            switch(val){
                case 1:
                    return root.$t("basic.orientationSelector.horizontal");
                case 2:
                    return root.$t("basic.orientationSelector.vertical");
                case 3:
                    return "".concat(root.$t("basic.orientationSelector.horizontal"), "&").concat(root.$t("basic.orientationSelector.vertical"));
                default:
                    return "-";
            }
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var store = root.$store;
        var detailDialog = computed(function() {
            return store.state.creative.detail.detailDialog;
        });
        var productSelectorRef = ref();
        var productTab = ref("view");
        var loading = ref(false);
        var optionTotal = ref(0);
        var options = ref([]);
        var projectInfo = ref({});
        var productInfo = ref(null);
        var btnDisabled = computed(function() {
            // 没有选择语言，按钮不可点击
            return !productInfo.value;
        });
        var basicInfolist = computed(function() {
            return [
                {
                    title: root.$t("playTurbo.videoProject.projectDrop.info.name"),
                    label: projectInfo.value["name"]
                },
                {
                    title: root.$t("playTurbo.videoProject.projectDrop.info.id"),
                    label: projectInfo.value["id"],
                    copy: true
                },
                {
                    title: root.$t("playTurbo.playableProject.playable.detail.templateName"),
                    label: projectInfo.value["template_name"]
                },
                {
                    title: root.$t("playTurbo.playableProject.playable.detail.direction"),
                    label: getOrientation(projectInfo.value["orientation"])
                },
                {
                    title: root.$t("playTurbo.videoProject.projectDrop.info.founder"),
                    label: projectInfo.value["adv_name"]
                },
                {
                    title: root.$t("playTurbo.videoProject.table.createTime"),
                    label: format(projectInfo.value["created_time"] * 1000, "YYYY/MM/DD HH:mm")
                },
                {
                    title: root.$t("playTurbo.videoProject.projectDrop.info.updater"),
                    label: projectInfo.value["adv_name"]
                },
                {
                    title: root.$t("playTurbo.videoProject.projectDrop.info.updateTime"),
                    label: format(projectInfo.value["updated_time"] * 1000, "YYYY/MM/DD HH:mm")
                }, 
            ];
        });
        var remoteMethod = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(query) {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!query) {
                                _ctx.next = 14;
                                break;
                            }
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return productList(query);
                        case 4:
                            res = _ctx.sent;
                            options.value = res.data.data.list ? res.data.data.list : [];
                            optionTotal.value = _.get(res, "data.data.total", 0);
                            _ctx.next = 12;
                            break;
                        case 9:
                            _ctx.prev = 9;
                            _ctx.t0 = _ctx["catch"](1);
                            console.log(_ctx.t0);
                        case 12:
                            _ctx.next = 15;
                            break;
                        case 14:
                            {
                                options.value = [];
                            }
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        9
                    ]
                ]);
            }));
            return function remoteMethod(query) {
                return _ref.apply(this, arguments);
            };
        }();
        function initProjectInfo() {
            return _initProjectInfo.apply(this, arguments);
        }
        function _initProjectInfo() {
            _initProjectInfo = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            loading.value = true;
                            ;
                            if (!(detailDialog.value.type === "ps")) {
                                _ctx.next = 10;
                                break;
                            }
                            _ctx.next = 6;
                            return getPSProjectInfo({
                                id: detailDialog.value.id
                            });
                        case 6:
                            res = _ctx.sent;
                            projectInfo.value = res.data || {};
                            _ctx.next = 14;
                            break;
                        case 10:
                            _ctx.next = 12;
                            return getGmakerProjectInfo({
                                project_id: detailDialog.value.id
                            });
                        case 12:
                            res = _ctx.sent;
                            projectInfo.value = res.data.data || {};
                        case 14:
                            productInfo.value = projectInfo.value.product_info;
                            loading.value = false;
                            _ctx.next = 21;
                            break;
                        case 18:
                            _ctx.prev = 18;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log(_ctx.t0);
                        case 21:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        18
                    ]
                ]);
            }));
            return _initProjectInfo.apply(this, arguments);
        }
        function productSubmit() {
            return _productSubmit.apply(this, arguments);
        }
        function _productSubmit() {
            _productSubmit = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            loading.value = true;
                            if (!(detailDialog.value.type === "ps")) {
                                _ctx.next = 6;
                                break;
                            }
                            _ctx.next = 4;
                            return relateProductPsProject({
                                id: projectInfo.value.id,
                                product_id: productInfo.value.id || 0
                            });
                        case 4:
                            _ctx.next = 8;
                            break;
                        case 6:
                            _ctx.next = 8;
                            return relateProductGmakerProject({
                                id: projectInfo.value.id,
                                product_id: productInfo.value.id || 0
                            });
                        case 8:
                            _ctx.next = 10;
                            return initProjectInfo();
                        case 10:
                            productTab.value = "view";
                            loading.value = false;
                            emit("update-success", 1);
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _productSubmit.apply(this, arguments);
        }
        var toEdit = function() {
            productTab.value = "create";
        };
        var toDelete = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            productInfo.value = {
                                id: 0
                            };
                            productSubmit();
                        case 2:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function toDelete() {
                return _ref.apply(this, arguments);
            };
        }();
        onMounted(function() {
            initProjectInfo();
        });
        return {
            optionTotal: optionTotal,
            productSelectorRef: productSelectorRef,
            productTab: productTab,
            options: options,
            remoteMethod: remoteMethod,
            loading: loading,
            btnDisabled: btnDisabled,
            projectInfo: projectInfo,
            productInfo: productInfo,
            basicInfolist: basicInfolist,
            handleCreateProduct: handleCreateProduct,
            handleSelectProduct: handleSelectProduct,
            handleSelectedProduct: handleSelectedProduct,
            productClose: productClose,
            productSubmit: productSubmit,
            openProductDialog: openProductDialog,
            copyLink: copyLink,
            toEdit: toEdit,
            toDelete: toDelete,
            getProductType: getProductType
        };
    }
});
